import { render, staticRenderFns } from "./PoiExhibition.vue?vue&type=template&id=0fae8766"
import script from "./PoiExhibition.js?vue&type=script&lang=js&external"
export * from "./PoiExhibition.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports